import React from 'react';
import { FaInstagram } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../config/routes';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-tr from-gray-800 via-gray-900 to-black text-white py-10 px-4 text-center">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex flex-col items-center md:items-start">
          <img src="/logo.png" alt="Mundolandia Logo" className="h-16 mb-2 " />
          <p className="text-sm text-gray-400">Parque de diversión en Santa Cruz de Tenerife</p>
        </div>

        <div className="flex flex-col items-center text-sm text-gray-400 space-y-2">
          <Link to={ROUTES.terms} className="hover:text-white transition">Condiciones de uso</Link>
          <Link to={ROUTES.privacyPolicy} className="hover:text-white transition">Política de privacidad</Link>
          <Link to={ROUTES.legalNotice} className="hover:text-white transition">Aviso legal</Link>
          <Link to={ROUTES.login} className="text-xs uppercase tracking-[0.22em] text-gray-500 hover:text-gray-300 transition">
            Acceso interno
          </Link>
        </div>

        <div className="flex flex-col items-center">
          <a
            href="https://www.instagram.com/mundolandiapark2/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center text-xl hover:text-pink-400 transition"
          >
            <FaInstagram />
            <span className="ml-2 text-sm">@mundolandiapark2</span>
          </a>
        </div>
      </div>

      <div className="border-t border-gray-600 mt-8 pt-4 text-sm text-gray-500">
        <p>© 2023 MundolandiaPark. Todos los derechos reservados. Diseñado por <span className="underline">Cloudlet tech</span>.</p>
      </div>
    </footer>
  );
}
